import React, { Component } from 'react';
import PropTypes from 'prop-types';
// These styles should go into the styleguide in the future.
import './ErrorBoundary.scss';

class ErrorBoundary extends Component {
  state = { hasError: false };

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  render() {
    const { background, title, content, children } = this.props;
    const { hasError } = this.state;

    if (hasError) {
      return (
        <div
          className='error-boundary'
          style={{ backgroundImage: `url(${background})` }}
        >
          <div className='error-boundary__container'>
            <div className='col-md-offset-7 col-xs-12 col-md-4'>
              <h1
                className='title-bg title-bg--box'
                style={{ fontSize: '40px' }}
              >
                <span className='title-bg__content'>{title}</span>
              </h1>
              <div className='card'>
                <div className='card__body'>{content}</div>
              </div>
            </div>
          </div>
        </div>
      );
    }

    return children;
  }
}

ErrorBoundary.propTypes = {
  title: PropTypes.oneOfType([PropTypes.node, PropTypes.string]),
  background: PropTypes.string,
  content: PropTypes.oneOfType([PropTypes.element, PropTypes.array]),
  children: PropTypes.node
};

export default ErrorBoundary;
